import { STEP_DOSSIER, STEP_COMPLETE, STEP_TRANSMISSION, STEP_TRANSFERRED, STEP_NET } from './stepKeys'

const statusCodeToStepKey = {
  // dossier
  C020: STEP_DOSSIER,

  // complete
  C050: STEP_COMPLETE,

  // transmission
  C0100: STEP_TRANSMISSION,

  // transferred
  Z0100: STEP_TRANSFERRED,
  TRERR: STEP_TRANSFERRED,
  R0400: STEP_TRANSFERRED,
  R0500: STEP_TRANSFERRED,

  // net
  S0100: STEP_NET,
  A0100: STEP_NET,
  S0100ERR: STEP_NET,
}

export default statusCodeToStepKey
